import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const BASE_URL = 'https://api.djkdurlach.de/index.php';

const fetchNews = async () => {
  const response = await fetch(`${BASE_URL}/news`, {
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error('News konnten nicht geladen werden.');
  }
  return response.json();
};

const saveNews = async (news) => {
  const formData = new FormData();
  Object.entries(news).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      formData.append(key, value);
    }
  });

  const response = await fetch(`${BASE_URL}/news`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  if (!response.ok) {
    const result = await response.json().catch(() => ({}));
    throw new Error(result.error || 'News konnten nicht gespeichert werden.');
  }
  return response.json();
};

const deleteNews = async (id) => {
  const response = await fetch(`${BASE_URL}/news/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error('News konnten nicht gelöscht werden.');
  }
  return response.json();
};

const reorderNews = async (ids) => {
  const response = await fetch(`${BASE_URL}/news/reorder`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ ids }),
  });
  if (!response.ok) {
    const result = await response.json().catch(() => ({}));
    throw new Error(result.error || 'Die Reihenfolge konnte nicht gespeichert werden.');
  }
  return response.json();
};

export const useNews = () => useQuery({
  queryKey: ['news'],
  queryFn: fetchNews,
});

export const useSaveNews = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: saveNews,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['news'] }),
  });
};

export const useDeleteNews = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteNews,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['news'] }),
  });
};

export const useReorderNews = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: reorderNews,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['news'] }),
  });
};
